import { FC } from 'react';

type LogoProps = {
  color: 'white' | 'blue';
  size?: 'normal' | 'mini';
  className?: string;
};

const Logo: FC<LogoProps> = ({ color, size = '', className }) => {
  const logoSrc = `/znario-logo-${color}${size === 'mini' ? '-mini' : ''}.svg`;

  return (
    <div className="flex items-center">
      <img src={logoSrc} alt="Znario Logo" className={className} />
    </div>
  );
};

export default Logo;
